const EN = [
  {
    cue: "Play the intro, then speak over it.",
    lines: [
      "This is *Dash AI Assistant*.",
      "*Power that talks back* — an AI assistant that meters, bills, recharges and fixes, for every tenant and Building Management in Indonesia's private and commercial areas.",
    ],
  },
  {
    cue: "Point at the candle photo first.",
    lines: [
      "Today, buildings still run on *guesswork*.",
      "Utility readings are manual, inaccurate and not transparent.",
      "Building Management can't monitor usage or bill tenants in real time.",
      "Every top-up or meter glitch waits for a *technician* — and tenants still struggle to *simply pay*.",
    ],
  },
  {
    cue: "Let the orbit animate, then walk around it.",
    lines: [
      "Dash AI is not just an app — it's a *companion*.",
      "It reminds you before your electricity runs out and recharges it for you.",
      "It's a digital cashier with QRIS payment.",
      "Chat with Building Management and neighbours, end-to-end encrypted.",
      "And when something breaks, you chat or *video call* the AI for technical help.",
    ],
  },
  {
    cue: "Live demo: tap 'My meter shows PERIKSA' → video call, then 'Remind tenants', then 'Simulate scan & pay'.",
    lines: [
      "Three surfaces, *one brain*.",
      "First, the tenant asks Dash AI — it diagnoses the meter and jumps into a video call.",
      "Second, Building Management sees every building live, and lets Dash AI remind low-credit tenants in one tap.",
      "Third, payment: QRIS, virtual account or e-wallet — paid, and the token goes *straight to the meter*.",
    ],
  },
  {
    cue: "Slow down on 'both sides see the same kWh'.",
    lines: [
      "The impact is social.",
      "It's community-based, it drives energy efficiency through prepaid self-control, and it makes payments transparent — both sides see the *same kWh* and the *same rupiah*.",
      "It digitalises Building Management and the UMKM kiosks around them.",
    ],
  },
  {
    cue: "Trace the diagram top to bottom.",
    lines: [
      "Technically, Dash is *AI-native*: the assistant *is* the interface.",
      "One platform serves many Building Managements with isolated data.",
      "Payments route across multiple gateways.",
      "And it ships as a PWA — installable from a link, no app-store friction.",
    ],
  },
  {
    cue: "Let the map pins land before speaking.",
    lines: [
      "This isn't an idea — it's *built on Power Manager*.",
      "*24 cities*, *8 segments*, live since *2020*, with clients for over five years.",
      "Regulated, metrology-certified, and trusted by malls, guesthouses and property developers.",
    ],
  },
  {
    cue: "Pause. Say the last line slowly, then stop.",
    lines: [
      "Personal AI assistants are becoming the interface for everything.",
      "Every building will have an *assistant*.",
      "In Indonesia, it's *Dash*. Thank you!",
    ],
  },
];

const ID = [
  {
    cue: "Putar video intro, lalu bicara di atasnya.",
    lines: [
      "Inilah *Dash AI Assistant*.",
      "*Listrik yang bisa diajak bicara* — asisten AI yang mencatat meter, menagih, mengisi token, dan memperbaiki masalah, untuk setiap tenant dan Building Management di kawasan privat dan komersial Indonesia.",
    ],
  },
  {
    cue: "Tunjuk foto lilin terlebih dahulu.",
    lines: [
      "Hari ini, gedung masih dikelola dengan *tebakan*.",
      "Pencatatan utilitas masih manual, tidak akurat, dan tidak transparan.",
      "Building Management tidak bisa memantau pemakaian atau menagih tenant secara real-time.",
      "Setiap isi token atau gangguan meter harus menunggu *teknisi* — dan tenant masih kesulitan untuk *sekadar membayar*.",
    ],
  },
  {
    cue: "Biarkan orbit beranimasi, lalu jelaskan satu per satu.",
    lines: [
      "Dash AI bukan sekadar aplikasi — ia adalah *pendamping*.",
      "Ia mengingatkan sebelum listrik Anda habis, dan mengisinya untuk Anda.",
      "Ia adalah kasir digital dengan pembayaran QRIS.",
      "Chat dengan Building Management dan tetangga, terenkripsi end-to-end.",
      "Dan saat ada masalah, Anda bisa chat atau video call dengan AI untuk bantuan teknis.",
    ],
  },
  {
    cue: "Demo langsung: tekan 'My meter shows PERIKSA' → video call, lalu 'Remind tenants', lalu 'Simulate scan & pay'.",
    lines: [
      "Tiga tampilan, *satu otak*.",
      "Pertama, tenant bertanya ke Dash AI — ia mendiagnosis meter dan langsung masuk ke video call.",
      "Kedua, Building Management melihat setiap gedung secara live, dan membiarkan Dash AI mengingatkan tenant yang saldonya menipis dalam satu ketukan.",
      "Ketiga, pembayaran: QRIS, virtual account, atau e-wallet — lunas, dan token *langsung terkirim ke meter*.",
    ],
  },
  {
    cue: "Pelankan di bagian 'kedua pihak melihat kWh yang sama'.",
    lines: [
      "Dampaknya bersifat sosial.",
      "Berbasis komunitas, mendorong efisiensi energi lewat kontrol prabayar mandiri, dan membuat pembayaran transparan — kedua pihak melihat *kWh dan rupiah yang sama*.",
      "Ia mendigitalisasi Building Management dan kios UMKM di sekitarnya.",
    ],
  },
  {
    cue: "Telusuri diagram dari atas ke bawah.",
    lines: [
      "Secara teknologi, Dash adalah *AI-native*: asisten itulah antarmukanya.",
      "Satu platform melayani banyak Building Management dengan data yang terisolasi.",
      "Pembayaran dirutekan ke berbagai payment gateway.",
      "Dan ia hadir sebagai PWA — bisa dipasang dari sebuah link, tanpa repot lewat app store.",
    ],
  },
  {
    cue: "Tunggu pin peta muncul sebelum bicara.",
    lines: [
      "Ini bukan sekadar ide — ini *dibangun di atas Power Manager*.",
      "*24 kota*, *8 segmen*, beroperasi sejak *2020*, dengan klien lebih dari lima tahun.",
      "Teregulasi, tersertifikasi metrologi, dan dipercaya oleh mal, guesthouse, dan pengembang properti.",
    ],
  },
  {
    cue: "Jeda. Ucapkan kalimat terakhir perlahan, lalu berhenti.",
    lines: [
      "Asisten AI pribadi sedang menjadi antarmuka untuk segalanya.",
      "Setiap gedung akan memiliki *asisten*.",
      "Di Indonesia, itulah *Dash*. Terima kasih!",
    ],
  },
];

export const NOTES = { "en-US": EN, "id-ID": ID };

